"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRegistryAPI = void 0;
var RegistryError_1 = require("../errors/RegistryError");
var loadAndParseLibraries_1 = require("../libraries/loadAndParseLibraries");
function filterStyleAssets(assets) {
    return assets.filter(function (asset) { return asset.type === 'style' && asset.extension === 'css'; });
}
function filterModelAssets(assets) {
    return assets.filter(function (asset) { return asset.type === 'model' && asset.extension === 'js'; });
}
function shouldIncludeLibrary(artifactId, artifactIds) {
    if (!artifactIds) {
        return true;
    }
    return artifactIds.includes(artifactId);
}
function componentsShouldExist(components, requestedComponents) {
    if (requestedComponents) {
        var error_1 = RegistryError_1.createException('component does not exist');
        var shouldThrow_1 = false;
        requestedComponents.forEach(function (componentName) {
            if (!components[componentName]) {
                shouldThrow_1 = true;
                error_1.withComponent(componentName);
            }
        });
        if (shouldThrow_1) {
            throw error_1;
        }
    }
}
function loadComponents(components, _a) {
    var requestedComponents = (_a === void 0 ? {} : _a).requestedComponents;
    return __awaiter(this, void 0, void 0, function () {
        var componentNames, pending, models;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    componentsShouldExist(components, requestedComponents);
                    componentNames = Object.keys(components).filter(function (componentName) {
                        return !requestedComponents || requestedComponents.includes(componentName);
                    });
                    pending = componentNames.map(function (componentName) { return __awaiter(_this, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _a = {
                                        componentName: componentName
                                    };
                                    return [4 /*yield*/, components[componentName]()];
                                case 1: return [2 /*return*/, (_a.model = _b.sent(),
                                        _a)];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(pending)];
                case 1:
                    models = _b.sent();
                    return [2 /*return*/, models.reduce(function (acc, _a) {
                            var model = _a.model, componentName = _a.componentName;
                            acc[componentName] = model;
                            return acc;
                        }, {})];
            }
        });
    });
}
function createRegistryAPI(registry, props) {
    if (props === void 0) { props = {
        libraries: [],
    }; }
    return __awaiter(this, void 0, void 0, function () {
        var components, libraries, runtime, allowComponentsOverride, artifactIds, api;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    components = {};
                    libraries = {};
                    return [4 /*yield*/, registry(__assign({ registerLibrary: function (artifactId, libraryComponents, libraryAssets) {
                                if (libraries[artifactId]) {
                                    throw RegistryError_1.createException('It is not possible to register library, it already exist')
                                        .withDetails("Library: " + artifactId)
                                        .withHint('Probably, provided libraries with the same artifact id to the registry');
                                }
                                libraries[artifactId] = {
                                    components: libraryComponents,
                                    assets: libraryAssets,
                                };
                            } }, props))];
                case 1:
                    runtime = _a.sent();
                    allowComponentsOverride = props.allowComponentsOverride || true;
                    artifactIds = loadAndParseLibraries_1.getLibrariesArtifactIds(props.libraries);
                    artifactIds.forEach(function (artifactId) {
                        /**
                         * libraries[artifactId] is empty when `registerLibrary` was not called with this `artifactId`.
                         * the case – when there are no components for this `artifactId` in lib's manifest
                         */
                        if (!libraries[artifactId]) {
                            return;
                        }
                        Object.keys(libraries[artifactId].components).forEach(function (componentName) {
                            if (!allowComponentsOverride && components[componentName]) {
                                throw RegistryError_1.createException('It is not possible to register component loader, it already exist')
                                    .withComponent(componentName)
                                    .withHint('Probably, component is duplicated in libraries');
                            }
                            components[componentName] =
                                libraries[artifactId].components[componentName];
                        });
                    });
                    api = {
                        isComponentExist: function (name) {
                            return components.hasOwnProperty(name);
                        },
                        getComponents: function () {
                            return components;
                        },
                        getLibraries: function () {
                            return libraries;
                        },
                        forEachLibrary: function (cb) {
                            Object.keys(libraries).forEach(function (artifactId) {
                                var library = libraries[artifactId];
                                cb(artifactId, library.components, library.assets);
                            });
                        },
                        forEachComponent: function (cb) {
                            Object.keys(components).forEach(function (componentName) {
                                cb(componentName, components[componentName]);
                            });
                        },
                        getComponentStatics: function (componentName) {
                            return components[componentName].statics;
                        },
                        getComponentsAssets: function (requestedComponents) {
                            return Object.keys(components)
                                .filter(function (componentName) {
                                return (!requestedComponents || requestedComponents.includes(componentName));
                            })
                                .reduce(function (acc, componentName) {
                                /**
                                 * check if asset's url was already added
                                 * for cases when components are loaded within batch
                                 */
                                var componentAssets = components[componentName].assets.filter(function (asset) {
                                    return !acc.find(function (existingAsset) { return existingAsset.url === asset.url; });
                                });
                                return __spreadArrays(acc, componentAssets);
                            }, []);
                        },
                        getComponentsModelJSAssets: function (requestedComponents) {
                            var assets = this.getComponentsAssets(requestedComponents);
                            return filterModelAssets(assets).filter(function (asset) { return !asset.part; });
                        },
                        getComponentsModelCSSAssets: function (requestedComponents) {
                            var assets = this.getComponentsAssets(requestedComponents);
                            return filterStyleAssets(assets).filter(function (asset) { return !asset.part; });
                        },
                        getCommonChunksJSAssets: function (requestedArtifactIds) {
                            return Object.keys(libraries)
                                .filter(function (artifactId) {
                                return shouldIncludeLibrary(artifactId, requestedArtifactIds);
                            })
                                .map(function (artifactId) {
                                return filterModelAssets(libraries[artifactId].assets).filter(function (asset) { return !!asset.chunk; });
                            })
                                .flat();
                        },
                        getCommonChunksCSSAssets: function (requestedArtifactIds) {
                            return Object.keys(libraries)
                                .filter(function (artifactId) {
                                return shouldIncludeLibrary(artifactId, requestedArtifactIds);
                            })
                                .map(function (artifactId) {
                                return filterStyleAssets(libraries[artifactId].assets).filter(function (asset) { return !!asset.chunk; });
                            })
                                .flat();
                        },
                        getHostModelJSAssets: function (requestedArtifactIds) {
                            return Object.keys(libraries)
                                .filter(function (artifactId) {
                                return shouldIncludeLibrary(artifactId, requestedArtifactIds);
                            })
                                .map(function (artifactId) {
                                return filterModelAssets(libraries[artifactId].assets);
                            })
                                .flat();
                        },
                        getHostModelCSSAssets: function (requestedArtifactIds) {
                            return Object.keys(libraries)
                                .filter(function (artifactId) {
                                return shouldIncludeLibrary(artifactId, requestedArtifactIds);
                            })
                                .map(function (artifactId) {
                                return filterStyleAssets(libraries[artifactId].assets);
                            })
                                .flat();
                        },
                        getLibrariesAssets: function () {
                            return Object.keys(libraries).reduce(function (acc, artifactId) {
                                acc.push.apply(acc, libraries[artifactId].assets);
                                return acc;
                            }, []);
                        },
                        getLibrariesCustomAssets: function () {
                            return this.getLibrariesAssets().filter(function (_a) {
                                var type = _a.type;
                                return !['hot', 'webpack-runtime', 'model', 'style'].includes(type);
                            });
                        },
                        getLibrariesArtifactIds: function () {
                            return Object.keys(libraries);
                        },
                        getLibrariesRuntimes: function () {
                            return Object.keys(libraries).reduce(function (acc, artifactId) {
                                acc.push.apply(acc, libraries[artifactId].assets
                                    .filter(function (asset) { return asset.type === 'webpack-runtime'; })
                                    .map(function (_a) {
                                    var url = _a.url;
                                    return url;
                                }));
                                return acc;
                            }, []);
                        },
                        getRegistryRuntime: function () {
                            return runtime;
                        },
                        loadComponent: function (componentName) {
                            if (!this.isComponentExist(componentName)) {
                                throw RegistryError_1.createException('Component does not exist').withComponent(componentName);
                            }
                            return components[componentName]();
                        },
                        loadComponentPart: function (componentName, part) {
                            if (!this.isComponentExist(componentName)) {
                                throw RegistryError_1.createException('Component does not exist').withComponent(componentName);
                            }
                            return components[componentName](part);
                        },
                        loadAllComponents: function () {
                            return loadComponents(components);
                        },
                        loadComponents: function (requestedComponents) {
                            return loadComponents(components, {
                                requestedComponents: requestedComponents,
                            });
                        },
                    };
                    return [2 /*return*/, api];
            }
        });
    });
}
exports.createRegistryAPI = createRegistryAPI;
//# sourceMappingURL=registryAPI.js.map